module.exports = __webpack_public_path__ + "img/icon-close.6b922ef1.svg";